import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import store from './store/store.js';
import { BrowserRouter } from 'react-router-dom';
import Notifier from './components/Notifications/Notifier';
import { ThemeProvider } from '@mui/material/styles';
import { buildTheme } from 'utils/themeUtils.js';

async function enableAPIMocking() {
    if (import.meta.env.VITE_MSW !== 'enabled') return;
    const { worker } = await import('./mocks/browser/serviceWorker.js');
    return worker.start({
        onUnhandledRequest() {}, //disable warnings for unhandeled requests
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = buildTheme();
enableAPIMocking().then(() => {
    root.render(
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <SnackbarProvider maxSnack={7} autoHideDuration={6000} preventDuplicate={true}>
                        <App />
                        <Notifier />
                    </SnackbarProvider>
                </ThemeProvider>
            </BrowserRouter>
        </Provider>,
    );
});
